// extracted by mini-css-extract-plugin
export default {"form_active":"CommentForm_form_active__JPU7V","title":"CommentForm_title__Meps9"};